import React from 'react';
import { motion } from 'framer-motion';

const Clips = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-16">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="text-5xl font-serif font-bold text-gray-900 dark:text-white mb-8 text-center">Community Clips</h1>
        <p className="text-xl text-gray-900 dark:text-purple-300 text-center mb-16">
          Explore iconic moments generated by the Weaver community.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Clip 1 */}
          <div className="bg-white dark:bg-purple-900/30 rounded-2xl overflow-hidden border border-gray-200 dark:border-purple-800 shadow-lg">
            <div className="h-48 bg-purple-200 dark:bg-purple-800 flex items-center justify-center">
              <img src="/clips/clip1.jpg" alt="The Neon Standoff" className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <h3 className="font-bold text-lg text-gray-900 dark:text-white mb-2">The Neon Standoff</h3>
              <p className="text-sm text-gray-900 dark:text-purple-300 line-clamp-3">
                Rain lashed against the pavement as the cyber-samurai drew her blade. The corp-sec drones hummed, their targeting lasers cutting through the smog...
              </p>
            </div>
          </div>

          {/* Clip 2 */}
          <div className="bg-white dark:bg-purple-900/30 rounded-2xl overflow-hidden border border-gray-200 dark:border-purple-800 shadow-lg">
            <div className="h-48 bg-amber-200 dark:bg-amber-900/40 flex items-center justify-center">
              <img src="/clips/clip2.jpg" alt="Dragon's Hoard" className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <h3 className="font-bold text-lg text-gray-900 dark:text-white mb-2">Dragon's Hoard</h3>
              <p className="text-sm text-gray-900 dark:text-purple-300 line-clamp-3">
                Gold coins cascaded like a waterfall as the massive creature shifted its weight. The rogue held her breath, entirely invisible but acutely aware of the dragon's gaze.
              </p>
            </div>
          </div>

          {/* Clip 3 */}
          <div className="bg-white dark:bg-purple-900/30 rounded-2xl overflow-hidden border border-gray-200 dark:border-purple-800 shadow-lg">
            <div className="h-48 bg-blue-200 dark:bg-blue-900/40 flex items-center justify-center">
              <img src="/clips/clip3.jpg" alt="First Contact" className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <h3 className="font-bold text-lg text-gray-900 dark:text-white mb-2">First Contact</h3>
              <p className="text-sm text-gray-900 dark:text-purple-300 line-clamp-3">
                The airlock hissed open. The entity floating beyond wasn't made of flesh or metal, but of crystalline light that sang in frequencies the crew could taste.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Clips;
